import Immutable from 'seamless-immutable';
import { createReducer, completeReducer } from 'redux-recompose';

import { actions } from './actions';

export const defaultState = {
  userTurns: [],
  turnId: null,
  updateTurn: null,
  updateTurnLoading: false,
  updateTurnError: null,
  createNewTurn: null,
  createNewTurnLoading: false,
  createNewTurnError: null
};

const reducerDescription = {
  primaryActions: [
    actions.GET_USER_TURNS,
    actions.CREATE_NEW_TURN,
    actions.UPDATE_TURN,
    actions.CANCELATION_TURN
  ],
  override: {
    [actions.SET_UPDATE_TURN_DATA]: (state, action) =>
      Immutable.merge(state, {
        turnId: action.payload
      }),

    [actions.CLEAN_UPDATE_TURN_DATA]: state =>
      Immutable.merge(state, {
        turnId: null,
        updateTurn: null,
        updateTurnLoading: false,
        updateTurnError: null,
        createNewTurn: null,
        createNewTurnLoading: false,
        createNewTurnError: null
      })
  }
};

export const reducer = createReducer(Immutable(defaultState), completeReducer(reducerDescription));
